import { ViewStyle } from "react-native"
import { palette } from "./palette"
import { spacing } from "./spacing"

export const layout: { [key: string]: ViewStyle } = {
  row: {
    flexDirection: "row",
  },
  verticallyCenteredColumn: {
    flexDirection: "column",
    alignItems: "center",
  },
  verticallyCenteredRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  centeredRow: {
    flexDirection: "row",
    justifyContent: "center",
  },
  centerContent: {
    alignItems: "center",
    justifyContent: "center",
  },
  fullHeight: {
    height: "100%",
  },
  fullWidth: {
    width: "100%",
  },
  flex_1: {
    flex: 1,
  },
  flex_2: {
    flex: 2,
  },
}

export const margins = {
  m1: {
    margin: spacing[1],
  },
  m2: {
    margin: spacing[2],
  },
  m3: {
    margin: spacing[3],
  },
  m4: {
    margin: spacing[4],
  },
  m5: {
    margin: spacing[5],
  },
  m6: {
    margin: spacing[6],
  },

  mt1: {
    marginTop: spacing[1],
  },
  mt2: {
    marginTop: spacing[2],
  },
  mt3: {
    marginTop: spacing[3],
  },
  mt4: {
    marginTop: spacing[4],
  },
  mt5: {
    marginTop: spacing[5],
  },
  mt6: {
    marginTop: spacing[6],
  },

  mb1: {
    marginBottom: spacing[1],
  },
  mb2: {
    marginBottom: spacing[2],
  },
  mb3: {
    marginBottom: spacing[3],
  },
  mb4: {
    marginBottom: spacing[4],
  },
  mb5: {
    marginBottom: spacing[5],
  },
  mb6: {
    marginBottom: spacing[6],
  },

  mr1: {
    marginRight: spacing[1],
  },
  mr2: {
    marginRight: spacing[2],
  },
  mr3: {
    marginRight: spacing[3],
  },
  mr4: {
    marginRight: spacing[4],
  },
  mr5: {
    marginRight: spacing[5],
  },
  mr6: {
    marginRight: spacing[6],
  },

  ml1: {
    marginLeft: spacing[1],
  },
  ml2: {
    marginLeft: spacing[2],
  },
  ml3: {
    marginLeft: spacing[3],
  },
  ml4: {
    marginLeft: spacing[4],
  },
  ml5: {
    marginLeft: spacing[5],
  },
  ml6: {
    marginLeft: spacing[6],
  },
}

export const borders: { [key: string]: ViewStyle } = {
  rounded: {
    borderRadius: 10,
  },
  dashed: {
    borderStyle: "dashed",
  },
}

export const backgrounds: { [key: string]: ViewStyle } = {
  white: {
    backgroundColor: palette.white,
  },
  lightBlue: {
    backgroundColor: palette.Background_blue,
  },
}

export const padding = (...values: Array<number | string>): ViewStyle =>
  getShortHand("padding", ...values)

export const margin = (...values: Array<number | string>): ViewStyle =>
  getShortHand("margin", ...values)

const getShortHand = (style: string, ...values: Array<number | string>) => {
  if (values.length === 1) {
    return { [style]: values[0] }
  }
  const _genCss = (...values: Array<number | string>) => ({
    [style + "Top"]: values[0],
    [style + "Right"]: values[1],
    [style + "Bottom"]: values[2],
    [style + "Left"]: values[3],
  })
  if (values.length === 2) {
    return _genCss(values[0], values[1], values[0], values[1])
  }
  if (values.length === 3) {
    return _genCss(values[0], values[1], values[2], values[1])
  }
  return _genCss(values[0], values[1], values[2], values[3])
}

export const flex = (flexGrow: number, flexShrink?: number, flexBase?: any) => ({
  flexGrow,
  flexShrink,
  flexBase,
})
